import React from 'react';
import { modalStore } from 'components/layout/modals/ModalStore';
import { getJobDisplayTitle } from '../openJobsData';
import ReferralCreate from './ReferralCreate';

export default function ReferralSent({ job, referredName }) {
	const close = () => {
		modalStore.closeDialog();
	};

	const referSomeoneElse = () => {
		modalStore.openModal(
			{ isV2: true, position: 'center' },
			<ReferralCreate job={job} />
		);
	};

	return (
		<div className="ExternalApplicationModal ExternalApplicationSuccess">
			<div className="external-application-modal-top">
				<button
					type="button"
					className="external-application-modal-close"
					onClick={close}
					aria-label="Close">
					<img src="/ats/icons/close-3-icon.svg" alt="" />
				</button>
			</div>
			<div className="external-application-success-body">
				<div className="external-application-success-icon">
					<img src="/ats/icons/external-application-success-chair.svg" alt="" />
				</div>
				<h2>Referral Sent!</h2>
				<p>
					We sent {referredName || 'them'} an invitation to apply
					<br />
					for the {getJobDisplayTitle(job) || 'this'} position.
				</p>
			</div>
			<div className="external-application-modal-footer">
				<button
					type="button"
					className="external-application-btn is-secondary"
					onClick={close}>
					Close
				</button>
				<button
					type="button"
					className="external-application-btn is-primary"
					onClick={referSomeoneElse}>
					Refer Someone Else
				</button>
			</div>
		</div>
	);
}
